export const PROJECTS_PAGE_CONTENT = `\
# Projects

What I've been working on and some highlights.
Projects hosted on [GitHub](https://github.com/amirsharapov).
Any projects that are not private, are linked below.

## Latest Projects 👨‍💻

- [**Website**](https://github.com/amirsharapov/amirsharapov-website):
    This website
- [**Remote Android API**](https://github.com/amirsharapov/android-client-device-app):
    Android app for remote control of an Android device.

## Highlights ⭐

- [**aiocdp**]():
    Performance-based library for remote browser control using Chrome DevTools Protocol and asyncio.
    ([Available on pypi](https://pypi.org/project/aiocdp/)).
- [**LOTRO Bot**](https://github.com/amirsharapov/lotro-bot-v4):
    A bot that plays Lord of the Rings Online.
- **OSRS Bot**: A bot that plays Old School RuneScape.
- **Video Factory**: A video editing tool that uses AI to generate generic videos from text.
- **eCommerce Store (Demo)**: One of my first projects to demonstrate my knowledge in full stack web development.
    - Frontend: [ReactJS](https://github.com/amirsharapov/amir-apparel-demo-ui-react)
    - Interchangeable Backend 1: [Java SpringBoot](https://github.com/amirsharapov/amir-apparel-demo-api-spring-boot)
    - Interchangeable Backend 2: [C# .NET Core](https://github.com/amirsharapov/amir-apparel-demo-api-dotnet)
    - Database: PostgreSQL
- **Finance App**: A personal finance application that uses a combination of web scraping and
    frontend UI work to provide a simplified investment decision-making process.
- **TOR Proxy**: An socks5 proxy that routes traffic through the TOR network.
- **LinkedIn Outreach Helper**: A tool that simplifies the outreach process on LinkedIn.

## The "Archive" 🗄️

You can view all (100+) repositories on my [GitHub](https://github.com/amirsharapov).

*(Heads up: It's a graveyard! Some are private, lots are archived, and for a select few I question what was going through my mind 😅.)*
`